import { render } from "./DataSubjectRequestForm.vue?vue&type=template&id=2a01f300&scoped=true"
import script from "./DataSubjectRequestForm.vue?vue&type=script&lang=js"
export * from "./DataSubjectRequestForm.vue?vue&type=script&lang=js"

import "./DataSubjectRequestForm.vue?vue&type=style&index=0&id=2a01f300&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a01f300"]])

export default __exports__